// extracted by mini-css-extract-plugin
module.exports = {"recent-completed-cme":"RecentCme_recent-completed-cme__3dvwd"};